import { PrismaClient } from "@prisma/client";

const prismaClientSingleton = () => {
  return new PrismaClient();
};

declare global {
  var prisma: undefined | ReturnType<typeof prismaClientSingleton>;
}

const prisma = globalThis.prisma ?? prismaClientSingleton();

// Cache on globalThis in every environment. On serverless (Vercel) warm
// invocations reuse the module scope, so this avoids spawning a new
// PrismaClient — and a fresh connection pool — per cold/warm boundary.
globalThis.prisma = prisma;

export default prisma;